import * as Yup from 'yup'

export const MESSAGES = {
  fieldRequired: "This field is required.",
  theseFieldsAreRequired: "These fields are required.",
  zipMaxLimit: "Can't add more than 10 digits.",
  imageRequired: "At least one photo is required.",
  photoUploadMaxLimit: "You must limit the number of photos to 25.",
  priceRequired: "This field is required and your price must be greater than $0.00",
  atLeastOneRequired: "This field is required (minimum 1).",
  atMostOneHundredPercent: "This field cannot exceed 100%.",
  atLeastZero: "This field is required. If you do not want to include this fee, enter 0.",
  atLeastTwenty: "This field is required and must be a minimum of $20",
  atLeastHalfRequired: "This field is required (minimum 0.5).",
}

export const ListingDetailsSchema = Yup.object().shape({
  listingName: Yup.string().required(MESSAGES.fieldRequired),
  address1: Yup.string().required(MESSAGES.fieldRequired),
  zip: Yup.string().required(MESSAGES.fieldRequired).max(10, MESSAGES.zipMaxLimit),
  city: Yup.string().required(MESSAGES.fieldRequired),
  state: Yup.string().required(MESSAGES.fieldRequired),
  houseType: Yup.string().required(MESSAGES.fieldRequired),
  bedrooms: Yup.number().min(1, MESSAGES.atLeastOneRequired).required(MESSAGES.atLeastOneRequired),
  sleeps: Yup.number().min(1, MESSAGES.atLeastOneRequired).required(MESSAGES.atLeastOneRequired),
  bathrooms: Yup.number().min(0.5, MESSAGES.atLeastHalfRequired).required(MESSAGES.atLeastHalfRequired),
  capacitySet: Yup.boolean().test('name', MESSAGES.theseFieldsAreRequired, (values, context) => {
    return context.parent.bathrooms > 0 && context.parent.bedrooms > 0 && context.parent.sleeps > 0
  })
});

export const ListingDescriptionSchema = Yup.object().shape({
  about: Yup.string().required(MESSAGES.fieldRequired),
  sleepingArrangements: Yup.string().required(MESSAGES.fieldRequired)
});

export const ListingPhotosSchema = Yup.object().shape({
  photos: Yup.array().min(1, MESSAGES.imageRequired).max(25, MESSAGES.photoUploadMaxLimit).required(MESSAGES.imageRequired)
});

export const ExtendedFeeSchema = Yup.object().shape({
  from: Yup.string().nullable().when(['enabled'], {
    is: (enabled) => enabled === true,
    then: Yup.string().typeError(MESSAGES.fieldRequired).required(MESSAGES.fieldRequired)
  }),
  to: Yup.string().nullable().when(['enabled'], {
    is: (enabled) => enabled === true,
    then: Yup.string().typeError(MESSAGES.fieldRequired).required(MESSAGES.fieldRequired)
  }),
  value: Yup.number().nullable().when(['enabled'], {
    is: (enabled) => enabled === true,
    then: Yup.number().typeError(MESSAGES.priceRequired).min(0.01, MESSAGES.priceRequired).required(MESSAGES.priceRequired)
  })
})

export const ListingPricingSchema = Yup.object().shape({
  pricing: Yup.object().shape({
    baseFee: Yup.number().typeError(MESSAGES.priceRequired).min(0.01, MESSAGES.priceRequired).required(MESSAGES.priceRequired),
    cleaningFee: Yup.number().typeError(MESSAGES.atLeastZero).min(0, MESSAGES.atLeastZero).required(MESSAGES.atLeastZero),
    petFee: Yup.number().typeError(MESSAGES.atLeastZero).min(0, MESSAGES.atLeastZero).required(MESSAGES.atLeastZero),
    deposit: Yup.number().typeError(MESSAGES.atLeastTwenty).min(20, MESSAGES.atLeastTwenty).required(MESSAGES.atLeastTwenty),
    extended_fee: ExtendedFeeSchema,
    weekend_fee: ExtendedFeeSchema
  })
});

export const DiscountSchema = Yup.object().shape({
  name: Yup.string().required(MESSAGES.fieldRequired),
  code: Yup.string().required(MESSAGES.fieldRequired),
  discountPercentage: Yup.number()
    .when(['discountType'], {
      is: (discountType) => discountType === 'Percentage',
      then: Yup.number().min(1, MESSAGES.atLeastOneRequired).max(100, MESSAGES.atMostOneHundredPercent).required(MESSAGES.atLeastOneRequired)
    }),
  discountDollarAmount: Yup.number()
    .when(['discountType'], {
      is: (discountType) => discountType === 'DollarAmount',
      then: Yup.number().min(1, MESSAGES.atLeastOneRequired).required(MESSAGES.atLeastOneRequired)
    })
});

export const ListingAddOnsSchema = Yup.object().shape({
  name: Yup.string().required(MESSAGES.fieldRequired),
  description: Yup.string().required(MESSAGES.fieldRequired),
  price: Yup.number().min(0.01, MESSAGES.priceRequired).required(MESSAGES.priceRequired)
})

export const AvailabilitySchema = Yup.object().shape({
  bookingSetting: Yup.string().required(MESSAGES.fieldRequired),
  adjustment: Yup.number()
    .when('availability', { is: 'Available', then: s => s.typeError(MESSAGES.priceRequired).min(0.01, MESSAGES.priceRequired).required(MESSAGES.priceRequired) })
});
